import { render, staticRenderFns } from "./CreateDeliveryCollection.vue?vue&type=template&id=39c239dc&"
import script from "./CreateDeliveryCollection.vue?vue&type=script&lang=js&"
export * from "./CreateDeliveryCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports